import { PanelTop, PanelLeft, PanelBottom, Maximize2, Minimize2 } from "lucide-react";

export function ViewControls({
  showHeader,
  showSidebar,
  showFooter,
  onToggle,
  immersiveOn,
  onImmersive,
}) {
  return (
    <div className="view-controls" data-testid="view-controls">
      <span className="view-controls-title">View</span>
      <button
        className={`view-btn${showHeader ? " view-btn-on" : ""}`}
        data-testid="view-toggle-header"
        onClick={() => onToggle("header")}
        title={showHeader ? "Hide top bar" : "Show top bar"}
      >
        <PanelTop size={15} strokeWidth={1.9} />
      </button>
      <button
        className={`view-btn${showSidebar ? " view-btn-on" : ""}`}
        data-testid="view-toggle-sidebar"
        onClick={() => onToggle("sidebar")}
        title={showSidebar ? "Hide sidebar" : "Show sidebar"}
      >
        <PanelLeft size={15} strokeWidth={1.9} />
      </button>
      <button
        className={`view-btn${showFooter ? " view-btn-on" : ""}`}
        data-testid="view-toggle-footer"
        onClick={() => onToggle("footer")}
        title={showFooter ? "Hide footer" : "Show footer"}
      >
        <PanelBottom size={15} strokeWidth={1.9} />
      </button>
      <div className="view-divider" />
      <button
        className={`view-btn view-btn-immersive${immersiveOn ? " view-btn-on" : ""}`}
        data-testid="immersive-toggle"
        onClick={onImmersive}
        title={immersiveOn ? "Exit immersive mode" : "Enter immersive mode"}
      >
        {immersiveOn ? <Minimize2 size={15} strokeWidth={2} /> : <Maximize2 size={15} strokeWidth={2} />}
      </button>
    </div>
  );
}
